/*
 * Copyright (c) 2021 TechnoL0g.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */

import Chain from '@/services/chain';
import CryptoJS from 'crypto-js';
import Explorer from '@/services/explorer';
import chain from "../../services/chain";

let counterUpdate = false;
let countUpdate = 0;

export default {
    namespaced: true,
    state: {
        accounts: {},
        current: {},
        balances: {
            "1.3.0": {
                symbol: 'BTS',
                amount: 0,
                precision: 5,
            }
        },
        balancesFiat: {},
        balancesLp: {},
        balancesHolderSth: [],
        portfolio: {},
        viewAccount: {},
        viewHistory: []
    },

    getters: {
        accounts: state => state.accounts,
        current: state => state.current,
        balances: state => state.balances,
        balancesFiat: state => state.balancesFiat,
        balancesLp: state => state.balancesLp,
        balancesHolderSth: state => state.balancesHolderSth,
        portfolio: state => state.portfolio,
        viewAccount: state => state.viewAccount,
        viewHistory: state => state.viewHistory,

    },

    mutations: {
        SET_RESET(state) {
            state.accounts = {};
            state.current = {};
            state.balances = {};
            state.balancesFiat = {};
            state.balancesLp = {};
            state.balancesHolderSth = {};
            state.portfolio = {};
            state.viewAccount = {};
            state.viewHistory = [];
        },
        SET_ACCOUNT(state, payload) {
            //const hashPin = CryptoJS.SHA384(payload.pin).toString();
            state.accounts[payload.user] = {
                user: payload.user,
                key: (CryptoJS.AES.encrypt(payload.key, payload.pin)).toString() || null,
                type: payload.type || 'password'
            }
        },
        SET_CURRENT(state, payload) {
            state.current = payload;
        },
        SET_BALANCES(state, payload) {
            state.balances = payload;
        },
        SET_BALANCES_FIAT(state, payload) {
            state.balancesFiat = payload;
        },
        SET_BALANCES_LP(state, payload) {
            state.balancesLp = payload;
        },
        SET_BALANCES_HOLDER(state, payload) {
            state.balancesHolderSth = payload;
        },
        SET_PORTFOLIO(state, payload) {
            state.portfolio = payload;
        },
        SET_VIEW_ACCOUNT(state, payload) {
            //state.viewAccount = null;
            state.viewAccount = payload.account;
        },
        SET_VIEW_HISTORY(state, payload) {
            state.viewHistory = payload.history;
        },
    },

    actions: {

        reset({commit}) {
            commit('SET_RESET')
        },
        async setAccount({commit}, values) {
            commit('SET_ACCOUNT', values)
        },
        async login({commit}, values) {
            let data = null;
            if (values.type === 'key') {
                data = await Chain.loginKey(values);
            }
            if (values.type === 'password') {
                data = await Chain.loginPassword(values);
            }
            return data;
        },
        async accountDecrypt({commit}, value) {
            //let currentHashPin = (CryptoJS.SHA384(value.pin)).toString()
            const account = (await this.getters['accounts/accounts'][value.user]);
            let accountBytes = CryptoJS.AES.decrypt(account.key.toString(), value.pin);
            return accountBytes.toString(CryptoJS.enc.Utf8);
        },
        async fullAccounts({commit}, ids = []) {
            let data = null;
            try {
                data = await Chain.getFullAccounts(ids); // быстре но может обрываться связь
            } catch(e) {
                data = await Explorer.getFullAccounts(ids);
            }
            return data;
        },
        async setCurrentAccount({commit}, values) {
            commit('SET_CURRENT', values)
        },

        async updateBalancesLPAssets({commit}, options) {
            //console.log('updateBalancesLPAssets')
            const assetsArr = await Explorer.getAssets(options['assets']); // RPC
            const assetsAll = await this.getters['assets/assets'];

            let assets = {};
            for (let i=0; i < assetsArr.length; i++) {
                assets[assetsArr[i].symbol] = assetsAll[assetsArr[i].symbol]
            }

            async function timeStringToGrapheneDate(time_string) {
                if (!time_string) return new Date("1970-01-01T00:00:00.000Z");
                if (!/Z$/.test(time_string)) {
                    time_string = time_string + "Z";
                }
                return new Date(time_string);
            }

            if (!options.userId) {
                return
            }
            const fullAccount = (await Chain.getFullAccounts([options.userId]));
            if (!fullAccount) {
                return null
            }
            const data = fullAccount[0][1];
            const balancesAll = data['balances'];
            const limitOrders = data['limit_orders'];
            const vestingBalances = data['vesting_balances'];
            const aKeys = Object.keys(assets);
            let tAssets = {};

            let balances = []
            for (let i=0; i < balancesAll.length; i++) {
                if (balancesAll[i]['balance'] > 0) {
                    balances.push(balancesAll[i])
                }
            }

            for (let i = 0; i < aKeys.length; i++) {
                try {
                    tAssets[assets[aKeys[i]].id] = {
                        symbol: aKeys[i],
                        id: assets[aKeys[i]].id,
                        precision: assets[aKeys[i]].precision,
                        amount: 0,
                        limit_orders: 0,
                        total: 0,
                    };
                } catch (e) {

                }






            }

           /** LP **/
            const assetsLp = await this.getters['assets/assetsLp'];

            const aKeysLp = Object.keys(assetsLp);
            let tAssetsLp = {};
            for (let i = 0; i < aKeysLp.length; i++) {
                tAssetsLp[assetsLp[aKeysLp[i]].share.id] = {
                    symbol: aKeysLp[i],
                    id: assetsLp[aKeysLp[i]].share.id,
                    poolId: assetsLp[aKeysLp[i]].share.for_liquidity_pool,
                    precision: assetsLp[aKeysLp[i]].share.precision,
                    amount: 0,
                    limit_orders: 0,
                    pool: assetsLp[aKeysLp[i]].pool,
                    supply: assetsLp[aKeysLp[i]].supply,
                    percent: 0,
                };
            }
            /** **/
            let portfolio = {};
            let allIds = [];
            if (balances) {
                for (let i = 0; i < data.balances.length; i++) {
                    balances[data.balances[i].asset_type] = data.balances[i];
                    allIds.push(data.balances[i].asset_type);
                }
                const allAssets = (await this.dispatch('app/getObjects', allIds));
                let assetsLpSymbols = [];

                for (let i = 0; i < allAssets.length; i++) {
                    // если lpId = null, тогда получаем все пулы с балансом
                    if (allAssets[i].for_liquidity_pool && !options.lpId) {
                        assetsLpSymbols.push(allAssets[i].symbol);
                        const assetLpData = await this.dispatch('assets/getLp', allAssets[i].symbol);
                        tAssetsLp[allAssets[i].id] = {
                            symbol: allAssets[i].symbol,
                            id: allAssets[i].id,
                            poolId: allAssets[i].for_liquidity_pool,
                            precision: allAssets[i].precision,
                            amount: 0,
                            limit_orders: 0,
                            pool: assetLpData.pool,
                            supply: assetLpData.supply,
                            percent: 0,
                        };
                    }

                    if (allAssets[i].for_liquidity_pool && options.lpId) {
                        if (allAssets[i].for_liquidity_pool === options.lpId) {
                            assetsLpSymbols.push(allAssets[i].symbol);
                        }
                    }

                    //for_liquidity_pool

                    portfolio[allAssets[i].id] = {
                        symbol: allAssets[i].symbol,
                        amount: balances[allAssets[i].id].balance,
                        precision: allAssets[i].precision,
                        real: (balances[allAssets[i].id].balance / 10 ** allAssets[i].precision).toFixed(allAssets[i].precision),
                        limit_orders: 0,
                        total: 0,
                    };
                    for (let j = 0; j < limitOrders.length; j++) {
                        if (limitOrders[j].sell_price.base.asset_id === allAssets[i].id) {
                            portfolio[allAssets[i].id].limit_orders = portfolio[allAssets[i].id].limit_orders + limitOrders[j].for_sale * 1;
                        }
                    }
                    portfolio[allAssets[i].id].total = (balances[allAssets[i].id].balance * 1 + portfolio[allAssets[i].id].limit_orders) / 10 ** allAssets[i].precision;
                }

                commit('SET_PORTFOLIO', portfolio);

                if (options.lpId && assetsLpSymbols[0]) {
                    const singleAsset = (await this.dispatch('app/getObjects', [options.lpId]));
                    const assetLpData = await this.dispatch('assets/getLp', assetsLpSymbols[0]);
                    tAssetsLp[singleAsset[0].id] = {
                        symbol: assetsLpSymbols[0],
                        id: singleAsset[0].id,
                        poolId: singleAsset[0].for_liquidity_pool,
                        precision: singleAsset[0].precision,
                        amount: 0,
                        limit_orders: 0,
                        pool: assetLpData.pool,
                        supply: assetLpData.supply,
                        percent: 0,
                    };
                }

                for (let i = 0; i < balances.length; i++) {

                    if (tAssets[balances[i].asset_type]) {
                        tAssets[balances[i].asset_type].amount = balances[i].balance * 1;
                        for (let j = 0; j < limitOrders.length; j++) {
                            if (limitOrders[j].sell_price.base.asset_id === balances[i].asset_type) {
                                tAssets[balances[i].asset_type].limit_orders = tAssets[balances[i].asset_type].limit_orders + limitOrders[j].for_sale * 1;
                            }
                        }
                        tAssets[balances[i].asset_type].total = (tAssets[balances[i].asset_type].amount + tAssets[balances[i].asset_type].limit_orders) / 10 ** tAssets[balances[i].asset_type].precision;
                    }

                    if (tAssetsLp[balances[i].asset_type]) {
                        tAssetsLp[balances[i].asset_type].amount = balances[i].balance;
                        tAssetsLp[balances[i].asset_type].percent = ((balances[i].balance / 10 ** tAssetsLp[balances[i].asset_type].precision) / tAssetsLp[balances[i].asset_type].supply * 100).toFixed(4) * 1;
                        for (let j = 0; j < limitOrders.length; j++) {
                            if (limitOrders[j].sell_price.base.asset_id === balances[i].asset_type) {
                                tAssetsLp[balances[i].asset_type].limit_orders = tAssetsLp[balances[i].asset_type].limit_orders + limitOrders[j].for_sale * 1;
                            }
                        }
                    }
                }

                commit('SET_BALANCES', tAssets);
                commit('SET_BALANCES_LP', tAssetsLp);

                let tmpHolder = [];
                for (let i = 0; i < vestingBalances.length; i++) {
                    if (vestingBalances[i].balance.amount > 0 && vestingBalances[i].balance.asset_id === '1.3.4099' && vestingBalances[i].balance_type !== 'market_fee_sharing') {
                        tmpHolder.push(vestingBalances[i].id);
                    }
                }
                const holderArr = await this.dispatch('app/getObjects', tmpHolder);
                let preparedVB = [];
                for (let i = 0; i < holderArr.length; i++) {
                    let available = false;
                    let daysLeft = 0;
                    const claimStartDate = await timeStringToGrapheneDate(holderArr[i]['policy'][1].start_claim);
                    const claimEndDate = new Date(claimStartDate.getTime() + holderArr[i]['policy'][1].vesting_seconds * 1000);
                    if (new Date() >= claimEndDate) {
                        available = true;
                        daysLeft = 0;
                    } else {
                        daysLeft = parseInt(claimEndDate.getTime() / 1000 - new Date().getTime() / 1000);
                        daysLeft = (daysLeft / 86400).toFixed(2);
                    }
                    preparedVB.push({
                        "id": holderArr[i].id,
                        "owner": holderArr[i].owner,
                        "balance": holderArr[i].balance,
                        "vesting_seconds": holderArr[i]['policy'][1].vesting_seconds,
                        "start_claim": holderArr[i]['policy'][1].start_claim,
                        "daysLeft": daysLeft,
                        "available": available,

                    })
                }
                commit('SET_BALANCES_HOLDER', preparedVB);
            }


        },

        /**
         * обновить балансы по всем пулам ликвидности
         * @param commit
         * @param options
         * @returns {Promise<null>}
         */
        async updateLpBalances({commit}, options) {
            //console.log('updateLpBalances')
            if (!options.userId) {
                return null;
            }
            const fullAccount = (await Chain.getFullAccounts([options.userId]));
            if (!fullAccount) {
                return null;
            }

            const data = fullAccount[0][1];
            const balancesAll = data['balances'];
            const limitOrders = data['limit_orders'];

            let balances = [];
            let allIds = [];
            let idsKeys = {};
            for (let i=0; i < balancesAll.length; i++) {
                if (balancesAll[i]['balance'] > 0) {
                    balances.push(balancesAll[i]);
                    allIds.push(balancesAll[i].asset_type);
                    idsKeys[balancesAll[i].asset_type] = balancesAll[i].balance * 1;
                }
            }

            /** LP **/
            const assetsLp = await this.getters['assets/assetsLp'];

            const aKeysLp = Object.keys(assetsLp);
            let tAssetsLp = {};
            for (let i = 0; i < aKeysLp.length; i++) {
                tAssetsLp[assetsLp[aKeysLp[i]].share.id] = {
                    symbol: aKeysLp[i],
                    id: assetsLp[aKeysLp[i]].share.id,
                    poolId: assetsLp[aKeysLp[i]].share.for_liquidity_pool,
                    precision: assetsLp[aKeysLp[i]].share.precision,
                    amount: 0,
                    limit_orders: 0,
                    pool: assetsLp[aKeysLp[i]].pool,
                    supply: assetsLp[aKeysLp[i]].supply,
                    percent: 0,
                };
            }
            /** **/

            if (balances) {
                const LpIdsDynamic = [];

                const allAssets = (await this.dispatch('app/getObjects', allIds));


                for (let i = 0; i < allAssets.length; i++) {
                    if (allAssets[i]['for_liquidity_pool']) {
                        LpIdsDynamic.push(allAssets[i].dynamic_asset_data_id)
                    }
                }

                const allPoolsDynamic =  (await this.dispatch('app/getObjects', LpIdsDynamic));
                let allPoolsDynamicById = {};
                for (let i=0; i < allPoolsDynamic.length; i++) {
                    allPoolsDynamicById[allPoolsDynamic[i].id.replace('2.3', '1.3')] = allPoolsDynamic[i]; //current_supply
                }
                let assetsLpSymbols = [];
                for (let i = 0; i < allAssets.length; i++) {
                    // если lpId = null, тогда получаем все пулы с балансом
                    if (allAssets[i]['for_liquidity_pool'] && !options.lpId && idsKeys[allAssets[i].id]) {

                        assetsLpSymbols.push(allAssets[i].symbol);
                        const assetLpData = await this.dispatch('assets/getLp', allAssets[i].symbol);
                        let limit_orders = 0;
                        for (let j = 0; j < limitOrders.length; j++) {
                            if (limitOrders[j].sell_price.base.asset_id === allAssets[i].id) {
                                limit_orders = limit_orders + limitOrders[j].for_sale * 1;
                            }
                        }
                        const supply = (allPoolsDynamicById[allAssets[i].id]['current_supply'] / 10 ** allAssets[i].precision).toFixed(allAssets[i].precision) * 1;
                        tAssetsLp[allAssets[i].id] = {
                            symbol: allAssets[i].symbol,
                            id: allAssets[i].id,
                            poolId: allAssets[i].for_liquidity_pool,
                            precision: allAssets[i].precision,
                            amount: idsKeys[allAssets[i].id], // lp balance
                            limit_orders: limit_orders,
                            pool: assetLpData.pool,
                            supply: supply, //assetLpData.supply,
                            percent: ((idsKeys[allAssets[i].id] / 10 ** allAssets[i].precision) / supply * 100).toFixed(4) * 1,
                        };

                    }
                }

                commit('SET_BALANCES_LP', tAssetsLp);
            }

        },


        async updateBalances({commit}, options) {
            //console.log('updateBalances')
            countUpdate++;

            //if (!counterUpdate) {
                //counterUpdate = true;
                async function timeStringToGrapheneDate(time_string) {
                    if (!time_string) return new Date("1970-01-01T00:00:00.000Z");
                    if (!/Z$/.test(time_string)) {
                        time_string = time_string + "Z";
                    }
                    return new Date(time_string);
                }

                if (!options.userId) {
                    return
                }
                const fullAccount = (await Chain.getFullAccounts([options.userId]));
                if (!fullAccount) {
                    return null
                }

                const data = fullAccount[0][1];
                const balancesAll = data['balances'];
                const limitOrders = data['limit_orders'];
                const vestingBalances = data['vesting_balances'];

                const assets = await this.getters['assets/assets'];
                const aKeys = Object.keys(assets);

                let balances = []
                for (let i=0; i < balancesAll.length; i++) {
                   if (balancesAll[i]['balance'] > 0) {
                        balances.push(balancesAll[i])
                    }
                }

                let tAssets = {};

                // defi err
                for (let i = 0; i < aKeys.length; i++) {

                        try {
                            tAssets[assets[aKeys[i]].id] = {
                                symbol: aKeys[i],
                                id: assets[aKeys[i]].id,
                                precision: assets[aKeys[i]].precision,
                                amount: 0,
                                limit_orders: 0,
                                total: 0,
                            };
                        } catch (e) {
                            console.log(e)
                        }




                }

                /** FIAT **/
                const assetsFiat = await this.getters['assets/assetsFiat'];
                const aKeysFiat = Object.keys(assetsFiat);
                let tAssetsFiat = {};
                for (let i = 0; i < aKeysFiat.length; i++) {
                    tAssetsFiat[assetsFiat[aKeysFiat[i]].id] = {
                        symbol: aKeysFiat[i],
                        id: assetsFiat[aKeysFiat[i]].id,
                        precision: assetsFiat[aKeysFiat[i]].precision,
                        amount: 0,
                        limit_orders: 0,
                    };
                }
                /** **/

                /** LP **/
                /*
                const assetsLp = await this.getters['assets/assetsLp'];

                const aKeysLp = Object.keys(assetsLp);
                let tAssetsLp = {};
                for (let i = 0; i < aKeysLp.length; i++) {
                    tAssetsLp[assetsLp[aKeysLp[i]].share.id] = {
                        symbol: aKeysLp[i],
                        id: assetsLp[aKeysLp[i]].share.id,
                        poolId: assetsLp[aKeysLp[i]].share.for_liquidity_pool,
                        precision: assetsLp[aKeysLp[i]].share.precision,
                        amount: 0,
                        limit_orders: 0,
                        pool: assetsLp[aKeysLp[i]].pool,
                        supply: assetsLp[aKeysLp[i]].supply,
                        percent: 0,
                    };
                }
                */
                /** **/
                let portfolio = {};
                let allIds = [];
                if (balances) {
                    for (let i = 0; i < balances.length; i++) {
                        balances[balances[i].asset_type] = balances[i];
                        allIds.push(balances[i].asset_type);
                    }
                    const allAssets = (await this.dispatch('app/getObjects', allIds));
                    for (let i = 0; i < allAssets.length; i++) {
                        portfolio[allAssets[i].id] = {
                            symbol: allAssets[i].symbol,
                            amount: balances[allAssets[i].id].balance,
                            precision: allAssets[i].precision,
                            real: (balances[allAssets[i].id].balance / 10 ** allAssets[i].precision).toFixed(allAssets[i].precision),
                            limit_orders: 0,
                            total: 0,
                        };
                        for (let j = 0; j < limitOrders.length; j++) {
                            if (limitOrders[j]['sell_price'].base.asset_id === allAssets[i].id) {
                                portfolio[allAssets[i].id].limit_orders = portfolio[allAssets[i].id].limit_orders + limitOrders[j].for_sale * 1;
                            }
                        }
                        portfolio[allAssets[i].id].total = (balances[allAssets[i].id].balance * 1 + portfolio[allAssets[i].id].limit_orders) / 10 ** allAssets[i].precision;
                    }
                    commit('SET_PORTFOLIO', portfolio);


                    for (let i = 0; i < balances.length; i++) {
                        if (tAssets[balances[i].asset_type]) {
                            tAssets[balances[i].asset_type].amount = balances[i].balance * 1;
                            for (let j = 0; j < limitOrders.length; j++) {
                                if (limitOrders[j].sell_price.base.asset_id === balances[i].asset_type) {
                                    tAssets[balances[i].asset_type].limit_orders = tAssets[balances[i].asset_type].limit_orders + limitOrders[j].for_sale * 1;
                                }
                            }
                            tAssets[balances[i].asset_type].total = (tAssets[balances[i].asset_type].amount + tAssets[balances[i].asset_type].limit_orders) / 10 ** tAssets[balances[i].asset_type].precision;
                        }

                        if (tAssetsFiat[balances[i].asset_type]) {
                            tAssetsFiat[balances[i].asset_type].amount = balances[i].balance * 1;
                            for (let j = 0; j < limitOrders.length; j++) {
                                if (limitOrders[j].sell_price.base.asset_id === balances[i].asset_type) {
                                    tAssetsFiat[balances[i].asset_type].limit_orders = tAssetsFiat[balances[i].asset_type].limit_orders + limitOrders[j].for_sale * 1;
                                }
                            }
                        }

                    }

                    commit('SET_BALANCES', tAssets);
                    commit('SET_BALANCES_FIAT', tAssetsFiat);
                    //commit('SET_BALANCES_LP', tAssetsLp);

                    let tmpHolder = [];
                    for (let i = 0; i < vestingBalances.length; i++) {
                        if (vestingBalances[i].balance.amount > 0 && vestingBalances[i].balance.asset_id === '1.3.4099' && vestingBalances[i].balance_type !== 'market_fee_sharing') {
                            tmpHolder.push(vestingBalances[i].id);
                        }
                    }
                    const holderArr = await this.dispatch('app/getObjects', tmpHolder);
                    let preparedVB = [];
                    for (let i = 0; i < holderArr.length; i++) {
                        let available = false;
                        let daysLeft = 0;
                        const claimStartDate = await timeStringToGrapheneDate(holderArr[i]['policy'][1].start_claim);
                        const claimEndDate = new Date(claimStartDate.getTime() + holderArr[i]['policy'][1].vesting_seconds * 1000);
                        if (new Date() >= claimEndDate) {
                            available = true;
                            daysLeft = 0;
                        } else {
                            daysLeft = parseInt(claimEndDate.getTime() / 1000 - new Date().getTime() / 1000);
                            daysLeft = (daysLeft / 86400).toFixed(2);
                        }
                        preparedVB.push({
                            "id": holderArr[i].id,
                            "owner": holderArr[i].owner,
                            "balance": holderArr[i].balance,
                            "vesting_seconds": holderArr[i]['policy'][1].vesting_seconds,
                            "start_claim": holderArr[i]['policy'][1].start_claim,
                            "daysLeft": daysLeft,
                            "available": available,
                        })
                    }
                    commit('SET_BALANCES_HOLDER', preparedVB);
                }
                //counterUpdate = false;
            //}
        },
        async getAccount({commit}, userId) {
            return await Explorer.getAccount(userId);
        },

        async searchAccount({commit}, values) {
            return await Chain.accountSearch(values.name, values.limit)
        },
    }
}
